export default __webpack_public_path__ + "static/media/bankh.73039f06.jpg";